import { Injectable } from '@angular/core';
import { GtmEvent } from 'src/app/core/enums/gtmEvent.enum';

const SCRIPT_ID = 'gtm-script';
const NOSCRIPT_ID = 'gtm-noscript';

declare global {
  interface Window {
    dataLayer?: any[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerService {
  insertScript(gtmId: string) {
    if (document.getElementById(SCRIPT_ID)) return;

    window.dataLayer = window.dataLayer || [];

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;

    const noscript = document.createElement('noscript');
    noscript.id = NOSCRIPT_ID;
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

    document.head.appendChild(script);
    document.body.insertBefore(noscript, document.body.firstChild);
  }

  pushEvent(event: GtmEvent, payload: Record<string, any> = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload });
  }

  removeScript() {
    document.getElementById(SCRIPT_ID)?.remove();
    document.getElementById(NOSCRIPT_ID)?.remove();
  }
}
